import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Collapse, Button,
} from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

import Section from './Section';

export default function Experience({ coach }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-5">
      <Row>
        <Col>
          <Button
            variant="link"
            className="fs-4 text-decoration-none text-gray-900 fw-semibold"
            onClick={() => setOpen(!open)}
            aria-controls={`coach-${coach.id}-experience-section`}
            aria-expanded={open}
          >
            Experience
          </Button>
        </Col>

        <Col xs="auto">
          <Button
            variant="light"
            className="ms-3 p-0 collapsed"
            style={{ borderRadius: '50%', borderBottomLeftRadius: '0' }}
            onClick={() => setOpen(!open)}
            data-bs-toggle="collapse"
            data-bs-target={`#coach-${coach.id}-experience-section`}
            aria-controls={`coach-${coach.id}-experience-section`}
            aria-expanded={open}
          >
            <IconWithText
              iconClassName="chevron-icon small-icon icon-toggle"
              wrapperClassName="p-2"
            />
          </Button>
        </Col>
      </Row>

      <Collapse in={open}>
        <Row id={`coach-${coach.id}-experience-section`} className="pt-2">
          <Col lg={6} xl={4}>
            {coach.attributes.level_education && (
              <>
                <h6 className="mb-3">
                  Education Level
                </h6>

                <div className="mb-4 small fw-light">
                  {coach.attributes.level_education}
                </div>
              </>
            )}

            <Section
              id={`coach-${coach.id}-universities`}
              title="Universities"
              collection={coach.attributes.universities}
            />
          </Col>

          <Col lg={6} xl={4}>
            <Section
              id={`coach-${coach.id}-career_levels`}
              title="Career Level"
              collection={coach.attributes.career_levels}
            />
          </Col>

          <Col lg={6} xl={4}>
            <Section
              id={`coach-${coach.id}-industries`}
              title="Industries"
              collection={coach.attributes.industries}
            />
          </Col>
        </Row>
      </Collapse>
    </div>
  );
}

Experience.propTypes = {
  coach: PropTypes.object.isRequired,
};
